/**
 * @Author: wuyang
 * @Date: 2024/1/29
 * @Description: ""
 */

/*
@param {string} url  静态资源url
@param {string} filename  静态资源文件名(可选)
@param {string} target
*/
import { downFileApi } from '@/api/common'

export const downFile = ({
	url,
	filename = 'DataX-未命名.png',
	target = true
}: {
	url: string
	filename?: string
	target?: boolean
}) => {
	return downFileApi(url).then((res) => {
		const downloadElement = document.createElement('a')
		downloadElement.style.display = 'none'
		downloadElement.href = URL.createObjectURL(res as any)
		if (target) {
			downloadElement.target = '_blank'
		}
		downloadElement.rel = 'noopener noreferrer'
		if (filename) {
			downloadElement.download = filename
		}
		document.body.appendChild(downloadElement)
		downloadElement.click()
		document.body.removeChild(downloadElement)
	})
}


   // 批量下载图片
   export const batchDownloadImages = (selectedUrls: any) => {
	if (selectedUrls.length === 0) {
		alert('请选择至少一张图片进行下载');
		return;
	}
	selectedUrls.forEach((url: string) => {
		fetch(url)
			.then(response => response.blob())
			.then(blob => {
				const a = document.createElement('a');
				const url = window.URL.createObjectURL(blob);
				a.href = url;
				// 从URL中提取文件名
				a.download = url.substring(url.lastIndexOf('/') + 1);
				document.body.appendChild(a);
				a.click();
				a.remove();
				window.URL.revokeObjectURL(url); // 释放之前创建的对象URL
			})
			.catch(error => console.error('下载失败:', error));
	});
};
